import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => {
  const { primary, secondary } = theme.palette;

  return {
    root: {
      display: "grid",
      columnGap: 12,
      alignItems: "center",
      backgroundColor: theme.palette.common.white,
      borderRadius: 0,
      paddingLeft: 24,
      paddingRight: 24,
      height: theme.heightDesktopPageHeader,
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        paddingLeft: 16,
        paddingRight: 16
      },
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        gridTemplateColumns: "1fr 1fr"
      },
      [theme.breakpoints.up(Breakpoints.SX_720)]: {
        gridTemplateColumns: "auto 1fr 1fr"
      },
      [theme.breakpoints.up(Breakpoints.MD_960)]: {
        gridTemplateColumns: "1fr 1fr 1fr"
      }
    },
    leftPart: {
      display: "flex",
      flexDirection: "column",
      flex: 1,
      marginRight: 30
    },
    currentlyViewing: {
      fontSize: 12,
      color: primary.light,
      lineHeight: "normal",
      marginBottom: 4
    },
    startExamButton: {
      display: "flex",
      justifySelf: "flex-end",
      borderRadius: 2,
      borderColor: secondary.dark,
      color: secondary.dark,
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      width: 136,
      height: 30,
      paddingLeft: 8,
      paddingRight: 8,
      [theme.breakpoints.down(Breakpoints.SX_720)]: {
        width: 30,
        minWidth: 20,
        "& .MuiButton-startIcon": {
          margin: 0
        }
      }
    },
    name: {
      position: "relative",
      fontSize: 20,
      color: primary.main,
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      lineHeight: "normal",
      whiteSpace: "nowrap",
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        cursor: "pointer"
      }
    },
    link: {
      textDecoration: "none",
      marginLeft: 12
    },
    button: {
      color: theme.palette.secondary.dark,
      borderColor: theme.palette.secondary.dark,
      fontSize: 14,
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      padding: "5px 24px",
      borderRadius: 2,
      lineHeight: "18px"
    },
    dialog: {
      "& .MuiDialogTitle-root": {
        paddingRight: 56
      }
    },
    horseData: {
      display: "flex",
      alignItems: "center"
    },
    emptyHorseName: {
      color: theme.palette.text.hint
    },
    horseNameButton: {
      textDecoration: "none",
      display: "flex",
      alignItems: "center",
      flexWrap: "nowrap"
    },
    arrowIcon: {
      color: "black",
      transform: "rotate(90deg)",
      transition: "transform 0.8s ease",
      fontSize: "16px",
      cursor: "pointer"
    },
    arrowIconReversed: {
      transform: "rotate(270deg)"
    },
    rootSearch: {
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        width: "100%"
      },
      [theme.breakpoints.up(Breakpoints.SX_720)]: {
        width: 268
      },
      [theme.breakpoints.up(Breakpoints.MD_960)]: {
        width: "100%",
        maxWidth: 380
      },
      [theme.breakpoints.up(Breakpoints.LG_1280)]: {
        width: 380
      }
    },
    itemsList: {
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        top: 100
      }
    },
    warningButton: {
      marginRight: 8
    },
    closeOnBackArrow: {
      position: "absolute",
      top: -56,
      left: 0,
      height: 56,
      width: 56,
      cursor: "pointer"
    }
  };
});
